import { render, staticRenderFns } from "./RemarkDetail.vue?vue&type=template&id=160e856c&scoped=true"
import script from "./RemarkDetail.vue?vue&type=script&lang=ts"
export * from "./RemarkDetail.vue?vue&type=script&lang=ts"
import style0 from "./RemarkDetail.vue?vue&type=style&index=0&id=160e856c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e856c",
  null
  
)

export default component.exports